import React, { useMemo } from "react";
import { Link as ChakraLink } from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";
const protocolRegex = /^https?:\/\//;
export function Link({ href, children, ...props }) {
    const isExternal = useMemo(() => {
        return props.isExternal ?? protocolRegex.test(href);
    }, [href, props.isExternal]);
    const linkProps = isExternal
        ? {
            href,
        }
        : {
            to: href,
        };
    return (React.createElement(ChakraLink, { as: isExternal ? "a" : ReactRouterLink, isExternal: isExternal, ...linkProps }, children));
}
